import api from '../../redux/api';

const BASE_URL = '/v1/seller/campaigns';

export const sellerCampaignsService = {
  getCampaigns: async (params = {}) => {
    const response = await api.get(BASE_URL, { params });
    return response.data;
  },

  getCampaign: async (campaignId) => {
    const response = await api.get(`${BASE_URL}/${campaignId}`);
    return response.data;
  },

  createCampaign: async (campaignData) => {
    const response = await api.post(BASE_URL, campaignData);
    return response.data;
  },

  updateCampaign: async (campaignId, campaignData) => {
    const response = await api.patch(`${BASE_URL}/${campaignId}`, campaignData);
    return response.data;
  },

  deleteCampaign: async (campaignId) => {
    const response = await api.delete(`${BASE_URL}/${campaignId}`);
    return response.data;
  },

  activateCampaign: async (campaignId) => {
    const response = await api.patch(`${BASE_URL}/${campaignId}/activate`, {});
    return response.data;
  },

  endCampaign: async (campaignId) => {
    const response = await api.patch(`${BASE_URL}/${campaignId}/end`, {});
    return response.data;
  },

  getCampaignStats: async (campaignId) => {
    const response = await api.get(`${BASE_URL}/${campaignId}/statistics`);
    return response.data;
  },

  getCampaignsStats: async () => {
    const response = await api.get(`${BASE_URL}/stats`);
    return response.data;
  },

  getCustomerTiers: async () => {
    const response = await api.get('/tiers/customer-tiers');
    return response.data;
  },

  getSellerRewardOptions: async (params = {}) => {
    const response = await api.get('/v1/seller/rewards', { params });
    return response.data;
  },

  searchCampaigns: async (params = {}) => {
    const { search, status, ...rest } = params;
    const query = { ...rest };
    if (search != null && search !== '') query.search = search;
    if (status != null && status !== '' && status !== 'all') query.status = status;
    const response = await api.get(`${BASE_URL}/search`, { params: query });
    return response.data;
  },

  getAccountCampaigns: async () => {
    const response = await api.get(`${BASE_URL}/account-campaigns`);
    return response.data;
  }
};

export default sellerCampaignsService;
